<template>
  <tr v-if="vmode === 'table'">
    <td>

      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="grey"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
              </span>
            </div>
          </v-card>
        </v-menu>

      <div
      class="rlink-hover color1--text"
      style="text-decoration: none;display:inline-flex;align-items: center;"
      @click.stop="$root.$timelineNav.open(item.archive_id)">
        <v-icon small color="color1" style="transition: none;">mdi-qrcode-scan</v-icon>
        <span class="ml-1">{{ item.archive_id }}</span>
      </div>
      <div>
        <v-icon small>mdi-barcode</v-icon>
        {{ item.batch_number }}
      </div>
    </td>
    <td>
      <div class="caption">
        <v-chip v-if="hasExpired"
        color="pink"
        x-small
        text-color="white">
          EXPIRED
        </v-chip>
        <div v-if="item.expiry_date" class="caption">
          {{ hasExpired? 'expired' : 'expires' }} {{ expiryDateHuman }} <br /> ({{ expiryDate }})
        </div>
      </div>
    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="localQuantity"
      :key="'c' + (item.definition || {}).id"
      :class="[error ? 'pink--text' : localQuantity === 0 ? 'textSecondary--text' : 'color1--text', 'borderless']"
      ></c-ms-ii>

      <v-progress-linear
      class="ma-0"
      :value="percent"
      :key="item.inventory_item_id"
      :color="error ? 'pink' : 'color1'"
      background-color="backgroundCard"
      height="5"
      rounded
      striped
      ></v-progress-linear>

      <div v-if="errorText" class="overline textSecondary--text" style="white-space: normal;">
        {{ errorText }}
      </div>

      <v-row class="align-center caption">
        <v-btn icon small @click="$emit('useWholeBatch', item)">
          <v-icon small>mdi-chevron-up</v-icon>
        </v-btn>
        <v-btn icon small @click="$emit('useNoneOfBatch', item)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        /&nbsp;
        
        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue="item.quantity"
        :key="'a' + (item.definition || {}).id"
        alwaysScale
        labelMode
        class="ma-2"
        ></c-ms-ii>

      </v-row>

    </td>
  </tr>
</template>


<script>
export default {
  props: ['item', 'quantity', 'vmode'],
  computed: {
    localQuantity: {
      get () {
        return this.quantity
      },
      set (nv) {
        this.$emit('onQuantityUpdate', nv)
      }
    },
    expiryDate () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('DD MMM YYYY')
      }
      return ''
    },
    expiryDateHuman () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment.utc(this.item.expiry_date).fromNow()
      }
      return ''
    },
    hasExpired () {
      return this.$moment.utc(this.item.expiry_date).isBefore()
    },
    percent () {
      // return (((this.item.quantity - this.localQuantity) / this.item.quantity)) * 100
      return 100 - (((this.item.quantity - this.localQuantity) / this.item.quantity) * 100) || 0
      // return (((this.localQuantity - this.item.quantity) / this.localQuantity)) * 100
      // return (1 - ((this.item.quantity - this.localQuantity) / this.item.quantity)) * 100 || 0
    },
    error () {
      if (this.localQuantity > this.item.quantity) {
        return true
      }
      return false
    },
    errorText () {
      if (this.localQuantity > this.item.quantity) {
        return 'Your debiting more than whats available'
      }
    }

  }
}
</script>